import { Box, useTheme } from "@mui/material"

export const EnvironmentDescription = () => {

    const theme = useTheme();

    const showDescription = globalThis.config.environment !== undefined &&
        globalThis.config.environment.toUpperCase() !== 'PROD';

    return (
        <>
            {showDescription &&
                <Box
                    id="env-desc"
                    sx={{
                        color: theme.palette.error.main,
                        backgroundColor: theme.palette.common.white,
                        marginRight: '10px',
                        fontWeight: 'bold',
                        fontSize: 16,
                        border: `1px solid ${theme.palette.common.white}`,
                        borderRadius: '10px',
                        width: '60px'
                    }}
                >
                    <Box
                        sx={{
                            textAlign: 'center',
                            border: `3px solid ${theme.palette.error.light}`,
                            borderRadius: '10px',
                            padding: '2px'
                        }}
                    >
                        {globalThis.config.environment}
                    </Box>
                </Box>
            }
        </>
    )
}
